import {useEffect, useState} from "react";
import {base64DecodeUnicode, toastSuccess} from "../../../assets/functions";
import Loading from "../../../component/Loading/Loading";
import {getManagerHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import {useNavigate, useParams} from "react-router-dom";
import TransactionForm from "../component/TransactionForm";
import {getAllTransactions, getTransactionById} from "../functions";
import Select from "../../../component/Select/Select";
import TextInput from "../../../component/TextInput/TextInput";
import {PickDateTimeWithoutContainer} from "../../../component/PickDate/PickDate";

const UpdateTransaction = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const {id} = useParams();
    const [transaction, setTransaction] = useState({
        personId: "",
        timestamp: Math.round(+new Date() / 1000),
        type: "INCREASE",
        method: "MANUAL",
        amount: "",
        idOfTransaction: "",
        description: "",
        privateDescription: "",
        destinationCardId: "",
        isVerified: true,
    });
    const [newTransactionStatus, setNewTransactionStatus] = useState({
        status: "CHOOSING",
        description: "",
        privateDescription: "",
    });
    useEffect(() => {
        (async () => {
            document.title = "ویرایش تراکنش مالی";
            const transaction = await getTransactionById(id);
            console.log(transaction);
            setTransaction(transaction);
            setIsLoading(false);
        })();

    }, []);

    const handleSubmit = async () => {
        setIsLoading(true);
        const headers = getManagerHeader();

        axios.put(baseCmsApiUrl + `transactions/${id}`, {
            transaction,
            newTransactionStatus
        }, {headers})
            .then((response) => {
                console.log(response)
                console.log(response.data)
                toastSuccess(base64DecodeUnicode(response.statusText));
                navigate("/transactions");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }

    if (isLoading)
        return <Loading/>

    const transactionOptions = [
        {
            label: "انتخاب ...",
            value: "CHOOSING"
        }, {
            label: "ایجاد شد",
            value: "INSERT"
        }, {
            label: "تایید شد",
            value: "VERIFIED"
        }, {
            label: "لغو شد",
            value: "CANCELED"
        }, {
            label: "حذف تراکنش",
            value: "DISABLE"
        },
    ];
    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">ویرایش تراکنش مالی</h1>
            </div>

            <TransactionForm transaction={transaction} onChange={(value) => {
                setTransaction(value)
            }}/>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <label className="card-title mb-2">تاریخچه تراکنش</label>
                            <table className={"table table-responsive text-center"}>
                                <thead>
                                <tr>
                                    <th>ردیف</th>
                                    <th>آیدی</th>
                                    <th>وضعیت</th>
                                    <th>ساعت</th>
                                    <th>توضیح مدیر</th>
                                    <th>آیدی مدیر</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    transaction.statuses.map((status, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{status.id}</td>
                                                <td>{status.status}</td>
                                                <td>
                                                    <PickDateTimeWithoutContainer timestamp={status.timestamp} disabled={true} />
                                                </td>
                                                <td>{status.privateDescription}</td>
                                                <td>{status.data}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-2">
                    <Select label={"وضعیت تراکنش"} options={transactionOptions} value={newTransactionStatus.status}
                            onChange={(value) => {
                                setNewTransactionStatus({...newTransactionStatus, status: value})
                            }}/>
                </div>
                <div className="col-md-5">
                    <TextInput label={"توضیح برای نمایش مشتری"} value={newTransactionStatus.description}
                               onChange={(value) => {
                                   setNewTransactionStatus({...newTransactionStatus, description: value})
                               }}/>
                </div>
                <div className="col-md-5">
                    <TextInput label={"توضیحات داخلی"} value={newTransactionStatus.privateDescription}
                               onChange={(value) => {
                                   setNewTransactionStatus({...newTransactionStatus, privateDescription: value})
                               }}/>
                </div>
            </div>


            <button className={"btn btn-secondary btn-lg w-100"} onClick={handleSubmit} disabled={isLoading}>ویرایش
                تراکنش مالی
            </button>
        </div>
    )
}

export default UpdateTransaction;